import "reflect-metadata";
import { Container } from "inversify";
import {
  UserRepo,
  UserRepositoryUID,
} from "@linkfluence/core/user/repositories/UserRepo";
import { Facet } from "@linkfluence/models/facet";
import { AiRepo, AiRepositoryUID } from "@radarly/core/ai/repositories/AiRepo";
import { PublicAiRepository } from "@radarly/core/ai/repositories/PublicAiRepository";
import {
  ClauseRepo,
  ClauseRepositoryUID,
} from "@radarly/core/clause/repositories/ClauseRepo";
import { SharedClauseRepo } from "@radarly/core/clause/repositories/SharedClauseRepo";
import {
  InfluencerRepository,
  InfluencerRepositoryUID,
} from "@radarly/core/influencer/repositories/InfluencerRepository";
import { PublicInfluencerRepository } from "@radarly/core/influencer/repositories/PublicInfluencerRepository";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "@radarly/core/insight-pages/repositories/InsightPageRepo";
import { PublicInsightPageRepo } from "@radarly/core/insight-pages/repositories/PublicInsightPageRepo";
import {
  InsightsRepository,
  InsightsRepositoryUID,
} from "@radarly/core/insights/repositories/InsightsRepository";
import { PublicInsightsRepository } from "@radarly/core/insights/repositories/PublicInsightsRepository";
import {
  ProductRepo,
  ProductRepositoryUID,
} from "@radarly/core/products/ProductRepo";
import { PublicProductRepo } from "@radarly/core/products/PublicProductRepo";
import {
  ProjectRepo,
  ProjectRepositoryUID,
} from "@radarly/core/project/repositories/ProjectRepo";
import { PublicProjectRepo } from "@radarly/core/project/repositories/PublicProjectRepo";
import { PublicSearchRepository } from "@radarly/core/search/repositories/PublicSearchRepository";
import {
  SearchRepository,
  SearchRepositoryUID,
} from "@radarly/core/search/repositories/SearchRepository";
import { PublicUserRepo } from "@radarly/core/user/repositories/PublicUserRepo";
import { PublicWorkspaceRepository } from "@radarly/core/workspace/repositories/PublicWorkspaceRepository";
import {
  WorkspaceRepository,
  WorkspaceRepositoryUID,
} from "@radarly/core/workspace/repositories/WorkspaceRepository";
import { PublicPage } from "@radarly/models/public-pages";

export function getContainer(publicPage: PublicPage) {
  const container = new Container();
  container
    .bind<SearchRepository>(SearchRepositoryUID)
    .toConstantValue(new PublicSearchRepository(publicPage));
  container
    .bind<UserRepo>(UserRepositoryUID)
    .toConstantValue(new PublicUserRepo(publicPage));
  container
    .bind<ProjectRepo>(ProjectRepositoryUID)
    .toConstantValue(new PublicProjectRepo(publicPage));
  container
    .bind<WorkspaceRepository>(WorkspaceRepositoryUID)
    .toConstantValue(new PublicWorkspaceRepository(publicPage));
  container
    .bind<InsightPageRepo>(InsightPageRepositoryUID)
    .toConstantValue(new PublicInsightPageRepo(publicPage.customPage));

  container.bind<ClauseRepo>(ClauseRepositoryUID).toConstantValue(
    new SharedClauseRepo({
      [Facet.ImageRecognitionLogos]: publicPage.ctx.brandLogos,
      [Facet.ImageRecognitionPersonIdentifications]:
        publicPage.ctx.personIdentifications,
    })
  );
  container.bind<ProductRepo>(ProductRepositoryUID).toConstantValue(
    new PublicProductRepo({
      [Facet.Product]: publicPage.ctx.products,
    })
  );
  container
    .bind<InsightsRepository>(InsightsRepositoryUID)
    .toConstantValue(new PublicInsightsRepository(publicPage));
  container
    .bind<InfluencerRepository>(InfluencerRepositoryUID)
    .toConstantValue(new PublicInfluencerRepository(publicPage));
  container
    .bind<AiRepo>(AiRepositoryUID)
    .toConstantValue(new PublicAiRepository(publicPage));
  return container;
}
